import type { BusinessProfileEntity } from './business-profile.model';
import { EntityListEditor } from './EntityListEditor';

export type SubsidiariesEditorProps = {
  subsidiaries: BusinessProfileEntity[];
  isReadOnly: boolean;
  isSaving: boolean;
  onSave: (subsidiaries: BusinessProfileEntity[]) => Promise<boolean>;
};

export function SubsidiariesEditor({
  subsidiaries,
  isReadOnly,
  isSaving,
  onSave,
}: SubsidiariesEditorProps) {
  return (
    <EntityListEditor
      values={subsidiaries}
      isReadOnly={isReadOnly}
      isSaving={isSaving}
      onSave={onSave}
      translationsNamespace="designSystem.networkSettings.businessProfile.subsidiaries"
    />
  );
}
